import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  meetingList: [],
}

export const getters = {}

export const mutations = {
  CACHE_MEETING_LIST(state, newList) {
    state.meetingList = newList
  },
  UPDATE_CURRENT_USER(state, newValue) {
    // eslint-disable-next-line no-undef
    saveState('auth.currentUser', newValue)
  },
}

export const actions = {
  fetchMeetingList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/meeting?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_MEETING_LIST', list)
        return list
      })
  },
  addMeeting({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/meeting`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  updateMeeting({ commit, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/meeting/${Data.id}`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  deleteMeeting({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/meeting/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  updateToken({ commit, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/meeting/zoomToken`, Data)
      .then((response) => {
        const data = response.data
        let currentUser = rootState.auth.currentUser.user
        currentUser.zoom_token = data.status.zoom_token
        commit('SET_CURRENT_USER', currentUser, { root: true })
        return data
      })
  },
  generateSignature({ commit, state, rootState }, { Data }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/meeting/generate-signature/${
          Data.meetingId
        }/${Data.role}`
      )
      .then((response) => {
        const data = response.data
        return data
      })
  },
  getStartUrl({ commit, state, rootState }, { Data }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/meeting/zak/${Data.meetingId}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
}
